var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "GRC"
  }, [_c('div', {
    staticClass: "card-headerfrm filter_main row",
    staticStyle: {
      "margin": "1px 3px",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.$t('editedjson.goodsReceiptCheck')))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading7
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading7 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: " col-md-6"
  }, [(_vm.smartPOCheck) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.smartPo')) + ": ")]), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.smartPOCheck))])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row ",
    staticStyle: {
      "border": "1px solid gray",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.dr')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_num|min:5'),
      expression: "'required|alpha_num|min:5'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.DRNo')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('removeHold.drNoPlaceHolder'),
      "name": "DRNo",
      "id": "DRNo",
      "data-vv-as": "DR number"
    },
    on: {
      "keyup": _vm.showSearchDR
    },
    model: {
      value: (_vm.addGRC.DRNo),
      callback: function($$v) {
        _vm.addGRC.DRNo = $$v
      },
      expression: "addGRC.DRNo"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.DRNo')),
      expression: "errors.has('saveGRCForm.DRNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.DRNo')))]), _vm._v(" "), (_vm.DRerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.DRerrors))]) : _vm._e()], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grnByScan.grnbyscan')) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isGrnScan),
      expression: "isGrnScan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isGrnScan) ? _vm._i(_vm.isGrnScan, null) > -1 : (_vm.isGrnScan)
    },
    on: {
      "change": _vm.grnScanEnable,
      "__c": function($event) {
        var $$a = _vm.isGrnScan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isGrnScan = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isGrnScan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isGrnScan = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.isfoundDR && _vm.productidcheck == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.eanCode')))])]) : _vm._e(), _vm._v(" "), (_vm.isfoundDR && _vm.productidcheck == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.productid')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('editedjson.productIdorEANcode'),
      "name": "productid",
      "id": "productid",
      "data-vv-as": "Product ID"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.showSearchProduct($event)
      }
    },
    model: {
      value: (_vm.addGRC.productid),
      callback: function($$v) {
        _vm.addGRC.productid = $$v
      },
      expression: "addGRC.productid"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.productid')),
      expression: "errors.has('saveGRCForm.productid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.productid')))]), _vm._v(" "), (_vm.IDerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.IDerrors))]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isfoundDR) ? _c('div', [(_vm.isFoundProductInPO) ? _c('div', [_c('div', {
    staticClass: "row ",
    staticStyle: {
      "border": "1px solid gray",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: " col-md-6"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grnByScan.scannedProductDetails')))])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productImage')))])])]), _vm._v(" "), _c('div', {
    staticClass: " col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.addGRC.productImage || 'static/img/defaultImg.png',
      "height": "150px"
    },
    on: {
      "error": function($event) {
        _vm.loadProductImageError(_vm.addGRC.productImage)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productId')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                    " + _vm._s(_vm.productId) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.eanCode')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                 " + _vm._s(_vm.addGRC.eancode) + "\n             ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productName')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                  " + _vm._s(_vm.addGRC.productname) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.colorAndSize')))])]), _vm._v(" "), (!_vm.productColor && !_vm.productSize) ? _c('div', {
    staticClass: "col-md-6"
  }) : _vm._e(), _vm._v(" "), (_vm.productColor || _vm.productSize) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" " + _vm._s(_vm.productColor) + " / " + _vm._s(_vm.productSize))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.mrpInr')))])]), _vm._v(" "), (!_vm.isMrpTrue) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                  " + _vm._s(_vm.addGRC.MRP) + "\n               ")]) : _vm._e(), _vm._v(" "), (_vm.isMrpTrue) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.MRP')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "name": "MRP",
      "id": "MRP",
      "options": _vm.mrpOptions
    },
    on: {
      "input": _vm.searchProductMRP
    },
    model: {
      value: (_vm.addGRC.MRP),
      callback: function($$v) {
        _vm.addGRC.MRP = $$v
      },
      expression: "addGRC.MRP"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.MRP')),
      expression: "errors.has('saveGRCForm.MRP')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.MRP')))])], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isfoundMRP && _vm.isFoundInvoiceQty) ? _c('div', [_c('div', {
    staticClass: "row ",
    staticStyle: {
      "border": "1px solid gray",
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.totalCheckedQty')) + " : ")])]), _vm._v(" "), (!_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|min_value:1|currentCheckQty'),
      expression: "'required|numeric|min_value:1|currentCheckQty'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.checkedqty')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "name": "checkedqty",
      "id": "checkedqty",
      "data-vv-as": "Checked quantity"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('currentCheckQty')
      }
    },
    model: {
      value: (_vm.addGRC.checkedqty),
      callback: function($$v) {
        _vm.addGRC.checkedqty = $$v
      },
      expression: "addGRC.checkedqty"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.checkedqty')),
      expression: "errors.has('saveGRCForm.checkedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.checkedqty')))]), _vm._v(" "), (_vm.checkQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.checkQtyerrors))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_vm._v("\n                   1\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalAcceptedQty')) + " : ")])]), _vm._v(" "), (!_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|totalAcceptQty'),
      expression: "'required|numeric|totalAcceptQty'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('acceptedqty')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "name": "acceptedqty",
      "id": "acceptedqty",
      "data-vv-as": "Accepted quantity"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('acceptqty')
      }
    },
    model: {
      value: (_vm.addGRC.acceptedqty),
      callback: function($$v) {
        _vm.addGRC.acceptedqty = $$v
      },
      expression: "addGRC.acceptedqty"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.acceptedqty')),
      expression: "errors.has('saveGRCForm.acceptedqty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.acceptedqty')))]), _vm._v(" "), (_vm.acceptQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.acceptQtyerrors))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [(!_vm.movetoreject) ? _c('span', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.movetoreject) ? _c('span', [_vm._v("0")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.lotControlCheck && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcList.lotNo')) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.lotControlCheck && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('lotno')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('grcList.LotNoPlaceHolder'),
      "id": "lotno",
      "name": "lotno",
      "data-vv-as": "Lot No",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.addGRC.lotno),
      callback: function($$v) {
        _vm.addGRC.lotno = $$v
      },
      expression: "addGRC.lotno"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.lotno')),
      expression: "errors.has('saveGRCForm.lotno')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.lotno')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isExpiryCol && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('srqc.shelfLife')) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.isExpiryCol && !_vm.isshelflife && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b', [_vm._v(_vm._s(this.addGRC.shelfLife))])]) : _vm._e(), _vm._v(" "), (_vm.isExpiryCol && _vm.isshelflife && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [(_vm.ShelflifeErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ShelflifeErrors))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showshelflifeflag && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.shelfLifeDuration')) + ". "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (_vm.showshelflifeflag && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('auditReport.shelflifePlaceHolder'),
      "name": "ShelfLife",
      "id": "ShelfLife"
    },
    model: {
      value: (_vm.ShelfLife),
      callback: function($$v) {
        _vm.ShelfLife = $$v
      },
      expression: "ShelfLife"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showshelflifeflag && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerceProduct.ShelfLifeUOMPlaceholder')) + ". "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]) : _vm._e(), _vm._v(" "), (_vm.showshelflifeflag && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShelfLifeuom1),
      expression: "ShelfLifeuom1"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ShelfLifeuom1')
    },
    attrs: {
      "name": "ShelfLifeuom1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShelfLifeuom1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getconfirmsaveshelflife]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerceProduct.ShelfLifeUOMPlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "year"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.year')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.month')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "day"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.day')))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.expControlCheck && _vm.shelflifecheckfordate && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcLotReport.manufactureDate')) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.expControlCheck && _vm.shelflifecheckfordate && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "data-vv-as": "Manufacture Date",
      "data-vv-scope": "saveGRCForm",
      "name": "mfgdate",
      "id": "mfgdate"
    },
    on: {
      "input": _vm.Expdatefunction
    },
    model: {
      value: (_vm.addGRC.mfgdate),
      callback: function($$v) {
        _vm.addGRC.mfgdate = $$v
      },
      expression: "addGRC.mfgdate"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('saveGRCForm.mfgdate')) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.mfgdate')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.expControlCheck && _vm.shelflifecheckfordate && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.expControlCheck && _vm.shelflifecheckfordate && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "data-vv-scope": "saveGRCForm",
      "data-vv-as": "Expiry Date",
      "name": "expdate",
      "id": "expdate"
    },
    on: {
      "input": _vm.Mfgdatefunction
    },
    model: {
      value: (_vm.addGRC.expdate),
      callback: function($$v) {
        _vm.addGRC.expdate = $$v
      },
      expression: "addGRC.expdate"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('saveGRCForm.expdate')) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.expdate')))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.isfoundReject) || (_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.totalRejectedQty')) + " : ")])]) : _vm._e(), _vm._v(" "), ((_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-5"
  }, [_vm._v("\n                    1\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-4"
  }) : _vm._e(), _vm._v(" "), (_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [(!_vm.isfoundReject) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.moveToReject
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('grnByScan.moveToReject')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.isfoundReject && !_vm.isGrnByScanEnable) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('rejectedqty')
    },
    attrs: {
      "type": "text",
      "name": "rejectedqty",
      "id": "rejectedqty"
    },
    on: {
      "keyup": function($event) {
        _vm.validateQty('rejectqty')
      }
    },
    model: {
      value: (_vm.addGRC.rejectedqty),
      callback: function($$v) {
        _vm.addGRC.rejectedqty = $$v
      },
      expression: "addGRC.rejectedqty"
    }
  }), _vm._v(" "), (_vm.rejectQtyerrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectQtyerrors))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.isfoundReject) || (_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rejectReason')))])]) : _vm._e(), _vm._v(" "), ((_vm.isfoundReject) || (_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "disabled": !_vm.isEnblRejectReason,
      "options": _vm.rejectOptions,
      "multiple": "",
      "item-color": "success",
      "placeholder": _vm.$t('boxList.reasonPlaceholder')
    },
    model: {
      value: (_vm.rejectReason),
      callback: function($$v) {
        _vm.rejectReason = $$v
      },
      expression: "rejectReason"
    }
  }), _vm._v(" "), (_vm.isEnblRejectReason && _vm.rejectReason == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("* " + _vm._s(_vm.$t('rtoGrn.rejectReasonError')))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasonErrors) ? _c('label', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.rejectReasonErrors))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), ((_vm.isfoundReject && _vm.addGRC.rejectedqty > 0) || (_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('editedjson.uploadRejectImages')))])])]) : _vm._e(), _vm._v(" "), ((_vm.isfoundReject && _vm.addGRC.rejectedqty > 0) || (_vm.isGrnByScanEnable && _vm.movetoreject)) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-left": "35px"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("  " + _vm._s(_vm.showimagetype))])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.productUploadUrl) ? _c('td', {
    staticClass: "text-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _c('img', {
    attrs: {
      "src": _vm.productUploadUrl,
      "width": "250px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(0, _vm.productUploadUrl)
      },
      "load": function($event) {
        _vm.myevent(_vm.productUploadUrl)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.productUploadUrl) ? _c('td', {
    staticClass: "text-center"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _c('img', {
    attrs: {
      "src": "static/img/noimg.png",
      "width": "100px",
      "height": "120px"
    },
    on: {
      "click": function($event) {
        _vm.viewImageUpload(1, null)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('td', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-backward fa-lg mt-3",
    on: {
      "click": function($event) {
        _vm.changeimage('prev')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-camera fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('rtogrnb2b.uploadProduct')
    },
    on: {
      "click": function($event) {
        _vm.uploadImageGrc('camera')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-file fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0000"
    },
    attrs: {
      "title": _vm.$t('editedjson.selectProductLabel')
    },
    on: {
      "click": function($event) {
        _vm.uploadImageGrc('file')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-forward fa-lg mt-3",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        _vm.changeimage('next')
      }
    }
  })])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "GRCfooter form-actions"
  }, [(_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-left": "110%"
    },
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": !_vm.isComplete || _vm.isLoading || (_vm.isGrnByScanEnable && !_vm.movetoreject)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveGRC('saveGRCForm')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.submit')))])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((!_vm.isFoundProductInPO && _vm.productData)) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)",
      "disabled": _vm.isProductNotInPO
    },
    on: {
      "click": function($event) {
        _vm.notInPOTrigger('notinpo')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.notInPo')))]), _vm._v("  \n              ")])]), _vm._v(" "), (_vm.isProductNotInPO) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productName')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.productData.productname))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productDescription')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(_vm._s(_vm.productData.productdescription))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.colorAndSize')))])]), _vm._v(" "), (!_vm.productData.color && !_vm.productData.size) ? _c('div', {
    staticClass: "col-md-2"
  }) : _vm._e(), _vm._v(" "), (_vm.productData.color || _vm.productData.size) ? _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(_vm._s(_vm.productData.color) + " / " + _vm._s(_vm.productData.size))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productImage')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.productData.productimage || 'static/img/defaultImg.png',
      "height": "150px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.mrpInr')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notinpo.mrp),
      expression: "notinpo.mrp"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "min": "0",
      "name": "mrp",
      "id": "mrp"
    },
    domProps: {
      "value": (_vm.notinpo.mrp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notinpo.mrp = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.notinpoError.mrp) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.notinpoError.mrp))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.quantity')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notinpo.qty),
      expression: "notinpo.qty"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "oninput": "validity.valid||(value='');",
      "name": "qty",
      "id": "qty"
    },
    domProps: {
      "value": (_vm.notinpo.qty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notinpo.qty = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.notinpoError.qty) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.notinpoError.qty))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "GRCfooter form-actions"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveNotInPO($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.submit')))]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "reset",
      "variant": "success"
    },
    on: {
      "click": _vm.resetScope
    }
  }, [_vm._v(_vm._s(_vm.$t('common.resetBtn')))])], 1)])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isFoundProductInPO && _vm.addGRC.MRP) ? _c('div', {
    staticClass: "col-md-5 ",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid gray",
      "padding": "20px"
    }
  }, [(_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('multiSellerPanel.poDetails')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.openpodetailsmodel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.viewPO')))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.po')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n              " + _vm._s(_vm.addGRC.pono) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grnByScan.skuPoQty')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                " + _vm._s(_vm.invoicePQuantity) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grnByScan.skuInvoiceQty')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('saveGRCForm.invoiceQty')
    },
    attrs: {
      "data-vv-scope": "saveGRCForm",
      "type": "text",
      "placeholder": _vm.$t('inwardList.inward.totalInvoiceQuantityPlaceholder'),
      "name": "invoiceQty",
      "id": "invoiceQty",
      "data-vv-as": "Invoice Quantity"
    },
    model: {
      value: (_vm.addGRC.invoiceQty),
      callback: function($$v) {
        _vm.addGRC.invoiceQty = $$v
      },
      expression: "addGRC.invoiceQty"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saveGRCForm.invoiceQty')),
      expression: "errors.has('saveGRCForm.invoiceQty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('saveGRCForm.invoiceQty')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty == false) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading,
      "variant": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveInvoiceQty()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))])], 1) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                  " + _vm._s(_vm.addGRC.invoiceQty) + "\n                  ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid gray",
      "padding": "20px"
    }
  }, [(_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grnByScan.skuGRNSummary')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundProductInPO) ? _c('div', {
    staticClass: "col-md-6"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.totalCheckedQty')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                  " + _vm._s(_vm.grcReceivedQty) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.acceptedQty')) + ".")])]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                    " + _vm._s(_vm.grcCheckedQty) + "\n                 ")]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcRejectReport.RejectedQty')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        " + _vm._s(_vm.grcRejectedQty) + "\n                   ")]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('crossDock.crossDockQty')))])]) : _vm._e(), _vm._v(" "), (_vm.isFoundInvoiceQty) ? _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                        " + _vm._s(_vm.crossdockquantity) + "\n                   ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": _vm.$t('editedjson.poDetails')
    },
    model: {
      value: (_vm.podetailsmodal),
      callback: function($$v) {
        _vm.podetailsmodal = $$v
      },
      expression: "podetailsmodal"
    }
  }, [_c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('i', {
    on: {
      "ok": function($event) {}
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table table-bordered podetailstable",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticStyle: {
      "background-color": "#e4dddd",
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.purchaseOrderDetails')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.poSpecial')) + ":  " + _vm._s(_vm.podata.pono))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.poDate')) + ": " + _vm._s(_vm._f("moment")(_vm.podata.podate)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.suplierName')) + ":  " + _vm._s(_vm.podata.suppliercompanyname))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.deliveryDate')) + ": " + _vm._s(_vm._f("moment")(_vm.podata.deliverbydateterms)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.podata.supplieraddressline1)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.podata.supplieraddresscity) + ",\n                      " + _vm._s(_vm.podata.supplieraddressstate) + ",\n                      " + _vm._s(_vm.podata.supplieraddresspin) + ",\n                      " + _vm._s(_vm.podata.supplieraddresscountry)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('editedjson.phoneNo')) + ".: " + _vm._s(_vm.podata.supplieraddressphone) + "\n                    ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.poDescription')) + ": " + _vm._s(_vm.podata.podescription) + "\n                      "), _c('br'), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('purchaseOrder.paymentTerms')) + ": " + _vm._s(_vm.podata.paymentterms) + "\n                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.emailId')) + " : " + _vm._s(_vm.supplierdata.emailid)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.panNumber')) + " : " + _vm._s(_vm.supplierdata.pannumber)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + " : " + _vm._s(_vm.supplierdata.contactperson) + "\n                    ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.FobTerms')) + " : " + _vm._s(_vm.podata.fobterms) + "\n                      "), _c('br'), _c('br'), _vm._v("\n                      " + _vm._s(_vm.$t('purchaseOrder.carrier')) + ": " + _vm._s(_vm.podata.carrierterms) + "\n                    ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('merchant.foodLicenseNo')) + " : " + _vm._s(_vm.supplierdata.foodlicenseno)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('merchant.drugLicenseNo')) + " : " + _vm._s(_vm.supplierdata.druglicenseno)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('merchant.gstNumber')) + " : " + _vm._s(_vm.supplierdata.suppliergstnno)), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.freightTerm')) + ": " + _vm._s(_vm.podata.freightterms)), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('inwardList.printData.comments')) + ": " + _vm._s(_vm.podata.comments) + "\n                    ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered podetailstable",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary",
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticStyle: {
      "background-color": "#e4dddd"
    }
  }, [_vm._v("  " + _vm._s(_vm.$t('purchaseOrder.shipTo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "#e4dddd"
    },
    attrs: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.invoiceTo')))])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "bottomfields"
  }, [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.podata.shiptocompanyname))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.podata.billtocompanyname))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.podata.shiptoaddressline1) + " " + _vm._s(_vm.podata.shiptoaddressline2))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.podata.billtoaddressline1) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("\n                          " + _vm._s(_vm.$t('client.city')) + " : " + _vm._s(_vm.podata.shiptoaddresscity)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('client.state')) + " : " + _vm._s(_vm.podata.shiptoaddressstate)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('editedjson.pinCoded')) + " : " + _vm._s(_vm.podata.shiptoaddresspin)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('client.country')) + " : " + _vm._s(_vm.podata.shiptoaddresscountry) + "\n                          ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("\n                          " + _vm._s(_vm.$t('client.city')) + "  : " + _vm._s(_vm.podata.billtoaddresscity)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('client.state')) + " : " + _vm._s(_vm.podata.billtoaddressstate)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('editedjson.pinCoded')) + " : " + _vm._s(_vm.podata.billtoaddresspin)), _c('br'), _vm._v("\n                          " + _vm._s(_vm.$t('client.country')) + " : " + _vm._s(_vm.podata.billtoaddresscountry) + "\n                          ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.phoneNo')) + ".: " + _vm._s(_vm.podata.shiptoaddressphone))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('editedjson.phoneNo')) + ".: " + _vm._s(_vm.podata.billtoaddressphone))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + ": " + _vm._s(_vm.podata.shiptoaddresscontactperson))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("  " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + ": " + _vm._s(_vm.podata.billtoaddresscontactperson))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {}, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "10px",
      "margin-left": "14px"
    }
  }, [_c('thead', {
    staticClass: "poform_tableheader"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100px",
      "display": "table-cell",
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "display": "table-cell",
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productName')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('srmaster.table.quantity')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.table.columns.hsnCode')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('grcLotReport.hsnRate')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.uom')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.mrp')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.unitPrice')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.discount')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.total')))]), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sgst')))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.sgstAmount')))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cgst')))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.cgstAmount')))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate != _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.igst')))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate != _vm.podata.shiptoaddressstate) ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('editedjson.igstAmount')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.totalWithTax')))])])]), _vm._v(" "), _vm._l((_vm.poloopdata), function(items) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(items.productlinenumber))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(items.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.hsncode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.hsnrate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.productunitofmeasure))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.mrp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.productunitprice)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(items.discount))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes)))]), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('td', [_vm._v(_vm._s(items.sgstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.sgstratepercent / 100)))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('td', [_vm._v(_vm._s(items.cgstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.cgstratepercent / 100)))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate != _vm.podata.shiptoaddressstate) ? _c('td', [_vm._v(_vm._s(items.igstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate != _vm.podata.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.igstratepercent / 100)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithtax)))])])])
  }), _vm._v(" "), (_vm.podata.supplieraddressstate != _vm.podata.shiptoaddressstate) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.subtotal')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithouttaxes)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.applicableTax')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.sgst + _vm.cgst + _vm.igst)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Freight')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.podata.shippingcharges)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "11"
    }
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithtax)))])])]) : _vm._e(), _vm._v(" "), (_vm.podata.supplieraddressstate == _vm.podata.shiptoaddressstate) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.subtotal')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithouttaxes)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.applicableTax')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.sgst + _vm.cgst + _vm.igst)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Freight')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.podata.shippingcharges)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "13"
    }
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))])])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithtax)))])])]) : _vm._e()], 2)])])])])], 1)]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary glass",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "30px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.print')))])]), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.cameraSection = false
      }
    },
    model: {
      value: (_vm.cameraSection),
      callback: function($$v) {
        _vm.cameraSection = $$v
      },
      expression: "cameraSection"
    }
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading7
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading7 = $event
      }
    }
  }), _vm._v(" "), (_vm.cameraSection && _vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveImage('GrcReject', 'file')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload")])])]) : _vm._e(), _vm._v(" "), (_vm.cameraSection && !_vm.fileSection) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cameralist),
      expression: "cameralist"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cameralist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cameralist = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.cameraSelected]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "hidden": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cameraApp.selectCamera')))]), _vm._v(" "), _vm._l((_vm.cameras), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.deviceId
      }
    }, [_vm._v(" " + _vm._s(client_obj.label))])
  })], 2)]), _vm._v(" "), _c('web-cam', {
    ref: "cameraImage",
    attrs: {
      "autoplay": "autoplay",
      "playsinline": _vm.playsinline,
      "height": 500,
      "width": 455,
      "screenshotFormat": _vm.screenshotFormat,
      "selectFirstDevice": _vm.selectFirstDevice
    },
    on: {
      "cameras": _vm.camerass
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.captureImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.capture')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.resetImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('cameraApp.retake')))])]), _vm._v(" "), (this.imageCaptured) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading7
    },
    on: {
      "click": function($event) {
        _vm.saveImage('OutsideProductimage', 'camera')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" " + _vm._s(_vm.$t('product.upload')))])]) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    on: {
      "ok": function($event) {
        _vm.viewImage = false
      }
    },
    model: {
      value: (_vm.viewImage),
      callback: function($$v) {
        _vm.viewImage = $$v
      },
      expression: "viewImage"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.productUploadUrl,
      "width": "400px",
      "height": "400px"
    }
  })])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.crossdockmodal = false
      }
    },
    model: {
      value: (_vm.crossdockmodal),
      callback: function($$v) {
        _vm.crossdockmodal = $$v
      },
      expression: "crossdockmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('crossDock.crossDockAlert')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closecrossdockmodal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('crossDock.moveCrossDockBin')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productID')) + "  : ")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.addGRC.productid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('crossDock.crossDockQty')) + "  : ")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(this.crossdockqty) + "/" + _vm._s(_vm.addGRC.acceptedqty))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "margin-left": "290px"
    }
  }, [(this.crossdockqty > 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.movement
    }
  }, [_vm._v(_vm._s(_vm.$t('crossDock.confirmMovement')))]) : _vm._e()])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-actions col-md-6 "
  }, [_c('div', {
    staticClass: "float-right"
  })])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09f05c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f05c06","hasScoped":true}!./src/views/components/goodsreceiptcheck/goodsreceiptcheck.component.html
// module id = 2168
// module chunks = 0